import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Search, Sparkles, Layers, Upload } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const TABS = [
    { key: "leads", to: "/app/find/leads", icon: Search },
    { key: "prospect", to: "/app/find/prospect", icon: Sparkles },
    { key: "segments", to: "/app/find/segments", icon: Layers },
    { key: "import", to: "/app/find/import", icon: Upload },
];

export default function FindLayout() {
    const { t } = useI18n();
    const location = useLocation();
    // Hide sub-nav on lead detail pages
    const showTabs = !/^\/app\/find\/leads\/[^/]+$/.test(location.pathname);
    return (
        <div className="flex flex-col min-h-[calc(100vh-64px)]">
            {showTabs && (
                <div className="border-b border-white/8 bg-brand-void/40 backdrop-blur-sm sticky top-16 z-20">
                    <div className="px-6 lg:px-10 flex items-center gap-1 overflow-x-auto no-scrollbar">
                        {TABS.map((tab) => (
                            <NavLink
                                key={tab.key}
                                to={tab.to}
                                data-testid={`find-tab-${tab.key}`}
                                className={({ isActive }) =>
                                    `relative inline-flex items-center gap-2 px-4 py-3 text-sm transition ${
                                        isActive
                                            ? "text-white"
                                            : "text-zinc-400 hover:text-white"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        <tab.icon size={15} />
                                        <span>{t.find.tabs[tab.key]}</span>
                                        {isActive && (
                                            <span className="absolute left-3 right-3 -bottom-px h-0.5 bg-gradient-to-r from-brand-indigo to-brand-cyan rounded-full" />
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
            <Outlet />
        </div>
    );
}
